<template>
  <nav class="navbar navbar-expand-md navbar-dark bg-dark">
    <a class="navbar-brand" href="#">Company</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02"
            aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
      <ul class="navbar-nav mr-auto mt-2 mt-md-0">
        <router-link exact tag="li" class="nav-item" to="/">
          <a class="nav-link">Projects</a>
        </router-link>
        <router-link exact tag="li" class="nav-item" to="/users">
          <a class="nav-link">Users</a>
        </router-link>
        <router-link exact tag="li" class="nav-item" to="/stats">
          <a class="nav-link">Statistics</a>
        </router-link>
      </ul>
      <ul class="navbar-nav my-md-0">
        <router-link exact tag="li" class="nav-item" :to="'/user/' + user.id">
          <a class="nav-link">Profile</a>
        </router-link>
        <li class="nav-item" @click="logout">
          <a href="#" class="nav-link">Logout</a>
        </li>
        <router-link v-if="isAdmin" exact tag="li" class="nav-item" to="/admin">
          <a class="nav-link">Settings</a>
        </router-link>
      </ul>
    </div>
  </nav>
</template>
<script>
export default {
  name: 'topbar',
  computed: {
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('token')
      window.location.reload()
    }
  }
}
</script>
